jQuery(document).ready(function () {
    const block = $('.services-slider-block');
    if (!block.get(0)) return;

    let swiper_instance;
    const swiper = block.find('.swiper');
    const swiper_wrapper = block.find('.swiper-wrapper');

    const swiper_args = {
        breakpoints: {
            1: {
                slidesPerView: 1
            },
            601: {
                slidesPerView: 'auto'
            },
            901: {
                slidesPerView: 1,

                grid: {
                    rows: 2,
                    fill: 'row'
                }
            }
        },
        navigation: {
            nextEl: '.services-slider-block__navs .slider-navs__next',
            prevEl: '.services-slider-block__navs .slider-navs__prev'
        },
        pagination: {
            el: '.services-slider-block__navs .slider-navs__pag',
            type: 'bullets'
        }
    };

    handleWindowResize();

    function handleWindowResize() {
        if ($(window).width() > 1200) {
            sliderEnd();
        } else {
            if (!swiper_instance) {
                sliderStart();
            }
        }
    }

    function sliderStart() {
        swiper.addClass('swiper');
        swiper_wrapper.addClass('swiper-wrapper');
        swiper_instance = new Swiper(swiper.get(0), swiper_args);
    }

    function sliderEnd() {
        swiper.removeClass('swiper');
        swiper_wrapper.removeClass('swiper-wrapper');
        if (swiper_instance) {
            swiper_instance.destroy();
            swiper_instance = undefined;
        }
    }
});
